<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <div v-if="!isAuthenticated" id="loginContainer">
      <div style="text-align:center;"><img src="./assets/contextedlogo.png"></div>
      <form>
        <div class="form-group">
          <label for="exampleInputEmail1">
            Email
            <input v-model="auth.email" type="email" class="form-control" autocomplete="off" id="exampleInputEmail1">
          </label>
        </div>
        <br />
        <div class="form-group">
          <label for="exampleInputPassword1">
            Passwort
            <input v-model="auth.password" type="password" @keyup.enter="login" class="form-control" autocomplete="off" id="exampleInputPassword1" >
          </label>
        </div>
        <div v-if="auth.message !== ''" class="alert" role="alert"
          :class="{'alert-danger': auth.hasErrors, 'alert-success': !auth.hasErrors}">
          <button @click="dismissAlert" type="button" class="close"><span aria-hidden="true">×</span></button>
          <p><strong>{{auth.message}}</strong></p>
        </div>
        <br />
        <div style="text-align:center;"><br />
          <button type="button" @click="login">Anmelden</button>
        </div>
        <!-- <button type="button" class="btn--inverted" @click="signUp">Registrieren</button> -->
      </form>
    </div>
    <div v-if="isAuthenticated" id="menubar">
      <!-- <h3 class="panel-title">{{displayName()}}</h3> -->
      <!-- <input v-model="auth.userName" type="text" class="form-control" id="inputUserName" placeholder="Username"> -->
      <!-- <button @click="updateProfile" type="button" class="btn btn-default">Nutzername ändern</button> -->
      <div v-if="auth.message !== ''" class="alert" role="alert"
        :class="{'alert-danger': auth.hasErrors, 'alert-success': !auth.hasErrors}">
        <button @click="dismissAlert" type="button" class="close"><span aria-hidden="true">×</span></button>
        <p><strong>{{auth.message}}</strong></p>
      </div>
      <!-- <br /> -->
      <div>
        <router-link to="/"><button type="button" v-bind:class="{ active: $route.path == '/' }"><svgicon icon="radar" width="40" height="40" color="#fff"></svgicon>context</button></router-link>
        <!-- <button type="button"><svgicon icon="marker" width="40" height="40" color="#fff"></svgicon>Liste</button> -->
        <router-link to="projekte"><button type="button" v-bind:class="{ active: $route.path == '/projekte' }"><svgicon icon="notes" width="40" height="40" color="#fff"></svgicon>projekte</button></router-link>
        <!-- <router-link to="tags"><button type="button" v-bind:class="{ active: $route.path == '/tags' }"><svgicon icon="tags" width="40" height="40" color="#fff"></svgicon>tags</button></router-link> -->
        <router-link to="merkliste"><button type="button" v-bind:class="{ active: $route.path == '/merkliste' }"><svgicon icon="bookmark" width="40" height="40" color="#fff"></svgicon>merkliste</button></router-link>
      </div>
      <div>
        <router-link to="optionen"><button type="button" v-bind:class="{ active: $route.path == '/optionen' }"><svgicon icon="settings" width="40" height="40" color="#fff"></svgicon>optionen</button></router-link>
        <!-- <button @click="signOut" type="button" class="logout"><svgicon icon="close" width="48" height="48" color="#fff"></svgicon>Logout</button> -->
      </div>
    </div>
    <router-view v-if="isAuthenticated"></router-view>
  </div>
</template>

<script>
import firebase from 'firebase/app'

var config = {
  apiKey: 'AIzaSyB-66DtYcFF4ByTsF8QwO7JB1JeeEKQM70',
  authDomain: 'contexteddesign.firebaseapp.com',
  databaseURL: 'https://contexteddesign.firebaseio.com',
  projectId: 'contexteddesign',
  storageBucket: 'contexteddesign.appspot.com',
  messagingSenderId: '440920075083'
}

firebase.initializeApp(config)

export default {
  name: 'App',
  data: function () {
    return {
      auth: {
        user: null,
        email: '',
        password: '',
        message: '',
        userName: '',
        hasErrors: false
      },
      beispiel: 'test123'
    }
  },
  computed: {
    isAuthenticated: function () {
      // This function changes the auth.user state when
      // the auth status of user changes.
      firebase.auth().onAuthStateChanged(user => {
        if (user) {
          this.auth.user = user // eslint-disable-line
        } else {
          this.auth.user = null // eslint-disable-line
        }
      })
      return (this.auth.user !== null)
    }
  },
  methods: {

    login: function (event) {
      var vm = this
      vm.auth.message = ''
      vm.auth.hasErrors = false

      if (vm.auth.email === '' || vm.auth.password === '') {
        alert('Please provide the email and password')
        return
      }
      // Sign-in the user with the email and password
      firebase.auth().signInWithEmailAndPassword(vm.auth.email, vm.auth.password)
        .then(function (data) {
          vm.auth.user = firebase.auth().currentUser
        }).catch(function (error) {
          vm.auth.message = error.message
          vm.auth.hasErrors = true
        })
    },

    signUp: function (event) {
      var vm = this
      vm.auth.message = ''
      vm.auth.hasErrors = false

      if (vm.auth.email === '' || vm.auth.password === '') {
        alert('Please provide the email and password')
        return
      }

      // Create a new user in firebase
      firebase.auth().createUserWithEmailAndPassword(vm.auth.email, vm.auth.password)
        .then(function (data) {
          // vm.auth.message = 'Successfully created user'
          firebase.database().ref('users/' + data.user.uid).set({
            email: data.user.email
          })

          vm.auth.user = firebase.auth().currentUser
          vm.auth.email = ''
          vm.auth.password = ''
        }).catch(function (error) {
          vm.auth.message = error.message
          vm.auth.hasErrors = true
        })
    },

    signOut: function () {
      // Signout the user using firebase
      firebase.auth().signOut()
        .then(function (error) {
          if (error) {
            this.auth.user = firebase.auth().currentUser
            this.auth.message = 'User signed out Successfully'
          }
        }.bind(this), function (error) {
          if (error) {
            alert('Failed to signout user, try again later')
          }
        })
    },

    /**
     * Update the user profile details.
     */
    updateProfile: function () {
      if (this.auth.userName === '') {
        alert('Please provide a username to update.')
        return
      }

      var user = firebase.auth().currentUser
      var vm = this

      user.updateProfile({
        displayName: vm.auth.userName
      }).then(function () {
        vm.auth.message = 'Successfully udpated user profile.'
      }, function (error) {
        if (error) {
          vm.auth.message = 'Failed to update user profile.'
          vm.auth.hasErrors = true
        }
      })
    },

    dismissAlert: function () {
      this.auth.message = ''
      this.auth.hasErrors = false
    },

    displayName: function () {
      return this.auth.user.displayName
        ? this.auth.user.displayName : this.auth.user.email
    }

  }
}
</script>

<style scoped  lang="scss">

#menubar {
  position: absolute;
  z-index: 1000;
  left: 0px;
  bottom: 0px;
  width: 100px;
  height: 100vh;
  background: $color-text;
  padding: 0;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  -webkit-box-orient: vertical;
  box-shadow: 0 2px 24px 0 rgba(38,50,56,0.1);
}

#menubar div:last-child button {
  border-bottom: none;
}

#menubar button, #menubar .btn {
  background-color: transparent;
  color: rgba(255,255,255,0.5);
  display: block;
  text-align: center;
  margin-left: 0 !important;
  width: 100%;
  box-sizing:border-box;
  margin-bottom: 0;
  text-transform: none;
  padding-bottom: 0.7em;
  font-weight: 400;
  border-radius: 0;
  text-decoration: none !important;

  &:hover {
    svg {
      opacity: 1;
    }
    color: rgba(255,255,255,0.7)

  }

  svg {
    margin-left: auto;
    margin-right: auto;
    margin-bottom: -0.75em;
    margin-top: 1em;
    opacity: 0.8;
    display: block;
  }

  a {
    text-decoration: none !important;
  }

  &.active {
    background-color: $color-highlight;
    color: #fff;
    color: $color-text;
    svg {
      opacity: 1;
    }
  }

  border-bottom: 1px solid rgba(#fff,0.1);
}

#loginContainer {
  width: 400px;
  margin: auto;
  max-width: 100%;
  margin-top: 100px;
  h1 {
    margin-bottom: 1.5em;
  }
  img {
    margin-top: 30px;
    width: 360px;
    margin-bottom: 50px;
  }
}

</style>



// WEBPACK FOOTER //
// src/App.vue